import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
/**
 * Main header molecule to be used whenever needed
 */
export class MainHeaderComponent {
  _noIcon = false;
  /**
   * @constructor
   */
  constructor(public location: Location) {}

  /**
   * Routes to previous page
   */
  toPreviousPage(): any {
    this.location.back();
  }

  /**
   * Decides if the icon appears
   * @return {boolean}
   */
  @Input()
  get noIcon(): boolean {
    return !this._noIcon;
  }

  /**
   * Sets icon's appearance
   * @param {any} value
   */
  set noIcon(value: any) {
    this._noIcon = coerceBooleanProperty(value);
  }
}
